import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sarf-detalhe-valor-mensal',
  templateUrl: './detalhe-valor-mensal.component.html'
})
export class DetalheValorMensalComponent  implements OnInit {

  @Input() muncipioSelecionado: any; 

  formDetalhe: FormGroup;

  /*
  *  Máscaras dos controles do formulário
  */
  pedEmpLiqMask = '00000.0000.00.0000000-0';
  codigoCredorMask = '0000.00000-00';
  cpfMask = '000.000.000-00';
  cnpjMask = '00.000.000/0000-00';

  nomeBanco = "";
  constructor( protected readonly fb: FormBuilder) {
    
   }  

  ngOnInit() {
    this.criarFormulario();
    

    this.atualizarFormulario();
  }


  criarFormulario() {
    this.formDetalhe = this.fb.group({
      municipio: this.fb.control({value: '', disabled: true}),
      indiceIPM: this.fb.control({value: '', disabled: true}),
      mesReferencia: this.fb.control({value: '', disabled: true}),
      valorDistribuido: this.fb.control({value: '', disabled: true}),
      valorArredondado: this.fb.control({value: '', disabled: false})
    });
  }

  atualizarFormulario() {
    this.atualizarControle('municipio', this.muncipioSelecionado.Municipio);
    this.atualizarControle('indiceIPM', this.muncipioSelecionado.indiceIPM);
    this.atualizarControle('mesReferencia', this.muncipioSelecionado.mesReferencia);
    this.atualizarControle('valorDistribuido', this.muncipioSelecionado.valorDistribuido);
    this.atualizarControle('valorArredondado', this.muncipioSelecionado.valorArredondado);
  }

 /*
  * Atualiza o conteúdo do controle verificando a nulidade do futuro conteúdo.
  */
  atualizarControle(controle: string, value: any) {
    this.formDetalhe.get(controle).setValue(value === null || value === undefined ? '-' : value.toString());
  }



 

}



// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-valor-mensal/detalhe-valor-mensal/detalhe-valor-mensal.component.ts